import React from 'react'
import { getInstitutional } from './../../core/api/institutional-provider'
import { Carousel, InstitutionalCard, About, SideBySideCard } from './../../components'
import { StyledWhyWrapper, StyledWhyTitle } from './styled'
import { Row, Col, Container } from 'react-bootstrap'
import { theme, slugify } from './../../common'
const Institucional = () => {

    const [institutionalData, setInstitutionalData] = React.useState()

    React.useEffect(() => {
        getInstitutional().then(res => setInstitutionalData(res.data))
    },[])

    return (
        <>
            {
                institutionalData && (
                    <>
                        <Carousel slides={institutionalData.slides} />

                        <Container fluid>
                            <Row>
                                <Col xs={12}>
                                    <StyledWhyTitle id='por_que_a_fr_instalacoes'>
                                        Por que a FR Instalações?
                                    </StyledWhyTitle>
                                </Col>
                            </Row>
                            
                            <Row>
                                <Col 
                                    md={{
                                        span: 10,
                                        offset: 1
                                    }}
                                    xs={12}
                                >
                                    <Row>
                                        <Col 
                                            lg={4}
                                            xs={12}
                                            className='my-lg-0 my-3'
                                        >
                                            <InstitutionalCard
                                                title={institutionalData.card_efficiency.title}
                                                image={institutionalData.card_efficiency.image}
                                                content={institutionalData.card_efficiency.content}
                                            />
                                        </Col>

                                        <Col
                                            lg={4}
                                            xs={12}
                                            className='my-lg-0 my-3'
                                        >
                                            <InstitutionalCard
                                                title={institutionalData.card_decisions.title}
                                                image={institutionalData.card_decisions.image}
                                                content={institutionalData.card_decisions.content}
                                            />
                                        </Col>

                                        <Col
                                            lg={4}
                                            xs={12}
                                            className='my-lg-0 my-3'
                                        >
                                            <InstitutionalCard
                                                title={institutionalData.card_relations_partnerships.title}
                                                image={institutionalData.card_relations_partnerships.image}
                                                content={institutionalData.card_relations_partnerships.content}
                                            />
                                        </Col>
                                    </Row>

                                </Col>


                            </Row>

                                
                            <Row className='mt-5'>
                                <Col lg={6} xs={12} style={{backgroundColor: theme.lightGrey}}>
                                    <SideBySideCard title={institutionalData.card_01.title} content={institutionalData.card_01.content}/>
                                </Col>

                                <Col lg={6} xs={12} style={{backgroundColor: theme.primary}}>
                                    <SideBySideCard primary title={institutionalData.card_02.title} content={institutionalData.card_02.content}/>
                                </Col>
                            </Row>

                                <Row className='my-5'>
                                    <Col xs={12}>
                                        {
                                            institutionalData?.about.map((about, index) => (
                                                <Row className='my-5'>
                                                    <Col 
                                                        md={{
                                                            span: 10,
                                                            offset: 1
                                                        }}
                                                        xs={12}
                                                    >
                                                        <About
                                                            key={index}
                                                            image_group={about.image_group}
                                                            content_group={about.content_group}
                                                            margin='5% 0px'
                                                            alignment={about.alignment}
                                                        />
                                                    </Col>
                                                </Row>
                                                ))
                                            }
                                    </Col>
                                </Row>
                        </Container>

                    </>
                )
            }
        </>
    )
}

export default Institucional